import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-common-id-exam-countdown-banner',
  templateUrl: './exam-countdown-banner.component.html',
  styleUrls: ['./exam-countdown-banner.component.scss']
})
export class CommonIdExamCountdownBannerComponent implements OnInit {
  // 共通テスト カウントダウンバナー設定
  // ※ 毎年度、日程確定時に更新すること
  private readonly examYear = 2027;
  private readonly examMonth = 1;
  private readonly examDay = 16;
  private readonly examMonthPadded = String(this.examMonth).padStart(2, '0');
  private readonly examDate = new Date(this.examYear, this.examMonth - 1, this.examDay); // 共通テスト1日目: 2027/01/16（土）
  private readonly examCountDownDisplayStartDate = new Date(2026, 1, 1); // バナー表示開始: 2026/02/01
  /** localStorage設定（bottom-toast-banner と同パターン） */
  private readonly storageKeyPrefix = 'examCountdownBannerClosedAt';
  private readonly storageKey = `${this.storageKeyPrefix}-${this.examYear}`;
  private readonly hideDurationMs = 60 * 24 * 60 * 60 * 1000; // 60日

  /** テンプレートバインディング用 */
  examDateLabel = `${this.examYear}/${this.examMonthPadded}/${this.examDay}・${this.examDay + 1}`; // 表示用テキスト
  daysRemaining: number;
  isBannerVisible = false;

  @Output() viewKakomonClick = new EventEmitter<void>();

  ngOnInit() {
    this.daysRemaining = this.calcDaysRemaining();
    this.isBannerVisible = this.shouldShow();
    this.cleanupLocalStorageKeys();
  }

  closeBanner() {
    if (!window.confirm('このバナーを60日間非表示にします。よろしいですか？')) {
      return;
    }
    this.isBannerVisible = false;
    localStorage.setItem(this.storageKey, Date.now().toString());
  }

  /** 今日から共通テスト1日目までの残り日数（0以上の整数） */
  private calcDaysRemaining(): number {
    const now = this.getNow();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const exam = new Date(this.examDate.getFullYear(), this.examDate.getMonth(), this.examDate.getDate());
    const diffMs = exam.getTime() - today.getTime();
    return Math.max(0, Math.ceil(diffMs / (24 * 60 * 60 * 1000)));
  }

  /** バナー表示判定 */
  private shouldShow(): boolean {
    const now = this.getNow();
    // 表示期間外
    if (now < this.examCountDownDisplayStartDate) return false;
    // 共通テスト当日以降（残り0日）
    if (this.daysRemaining < 1) return false;
    // ×ボタンで非表示中（60日間）
    if (this.isHiddenByUser()) return false;
    return true;
  }

  /** ユーザーが×で閉じた後の60日間非表示チェック */
  private isHiddenByUser(): boolean {
    const closedAt = localStorage.getItem(this.storageKey);
    if (!closedAt) return false;
    const closedTime = parseInt(closedAt, 10);
    return Date.now() - closedTime < this.hideDurationMs;
  }

  private cleanupLocalStorageKeys(): void {
    // 逆順で安全に削除
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (!key) continue;

      if (key.startsWith(this.storageKeyPrefix) && key !== this.storageKey) {
        localStorage.removeItem(key);
      }
    }
  }

  private getNow(): Date {
    // テスト用
    // return new Date(2027, 0, 15);

    // 本番
    return new Date();
  }
}
